/**
 * Portal analytics events per portal-phases.md (Workstream F).
 * Lightweight event bus — fires to console in dev, wires to provider later.
 */

export type PortalEventType =
  // Landing funnel
  | 'landing_view'
  | 'demo_portal_open'
  | 'sop_paste'
  | 'sop_upload'
  | 'template_select'
  | 'portal_generate_start'
  | 'portal_generate_complete'
  | 'portal_generate_error'
  // Portal engagement
  | 'portal_view'
  | 'portal_tab_switch'
  | 'step_view'
  | 'step_interaction'
  | 'step_complete'
  // Tools & delegation
  | 'tool_add'
  | 'tool_connect'
  | 'delegation_send'
  | 'delegation_accept'
  // Auth & conversion
  | 'auth_gate_shown'
  | 'auth_start'
  | 'auth_complete'
  | 'portal_save'
  // Growth
  | 'portal_publish'
  | 'template_fork'
  | 'template_chip_click'
  | 'public_template_view'
  | 'invite_send'
  | 'invite_accept';

export interface PortalEvent {
  event: PortalEventType;
  userId?: string;
  sessionId: string;
  portalId?: string;
  stepId?: string;
  metadata?: Record<string, unknown>;
  timestamp: string;
  source: 'web' | 'email' | 'api';
}

const SESSION_KEY = 'planapus_session_id';

function getOrCreateSessionId(): string {
  let sid = sessionStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = `s_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
    sessionStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

/**
 * Fire an analytics event. Currently logs in dev; swap body for Mixpanel/Amplitude later.
 */
export function trackPortalEvent(
  event: PortalEventType,
  opts?: {
    userId?: string;
    portalId?: string;
    stepId?: string;
    metadata?: Record<string, unknown>;
  },
): void {
  const payload: PortalEvent = {
    event,
    sessionId: getOrCreateSessionId(),
    timestamp: new Date().toISOString(),
    source: 'web',
    ...opts,
  };

  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.log('[PortalAnalytics]', payload.event, payload);
  }

  // Future: window.analytics?.track(event, payload);
}
